import { ALERT_SEVERITY, ERROR_MESSAGES, ROLE_TYPE } from '../constants';
import { loadProfile as loadCompanyProfile } from './company/profile';
import { loadProfile as loadVendorProfile } from './vendor/profile';
import { loadUserProfile } from './company/user/profile';
const BASE_PATH = 'APP';


/*****************************WORK_SCOPE Type Data************************************/
export const SET_WORK_SCOPE_TYPES = `${BASE_PATH}/SET_WORK_SCOPE_TYPES`;
export const IS_SET_WORK_SCOPE_TYPES_LOADING = `${BASE_PATH}/IS_SET_WORK_SCOPE_TYPES_LOADING`;
export const SET_WORK_SCOPE_TYPES_ERROR = `${BASE_PATH}/SET_WORK_SCOPE_TYPES_ERROR`;

export const loadWorkScopeTypes = () =>
    (dispatch, getState, client) => {
        dispatch(setIsWorkScopeTypesLoading(true));
        dispatch(setWorkScopeTypesError(""));

        client.get('/common/work_scope_types').
            then(res => res.data).then(result => {
                dispatch(setIsWorkScopeTypesLoading(false));
                if (result.isSuccess &&
                    result.data.workScopeTypes) {
                    dispatch(setWorkScopeTypes(result.data.workScopeTypes));
                } else {
                    dispatch(setWorkScopeTypesError(result.errorMessage ? result.errorMessage :
                        ERROR_MESSAGES.FAILED_TO_LOAD_WORK_SCOPE_TYPES));
                }
            }).catch(error => {
                dispatch(setIsWorkScopeTypesLoading(false));
                dispatch(setWorkScopeTypesError(ERROR_MESSAGES.FAILED_TO_LOAD_WORK_SCOPE_TYPES));
            });
    }

export const setWorkScopeTypes = (types) => ({
    type: SET_WORK_SCOPE_TYPES,
    types
});

export const setIsWorkScopeTypesLoading = (isLoading) => ({
    type: IS_SET_WORK_SCOPE_TYPES_LOADING,
    isLoading
});

export const setWorkScopeTypesError = (errorMessage) => ({
    type: SET_WORK_SCOPE_TYPES_ERROR,
    errorMessage,
});

const initialWorkScopeTypesData = {
    isLoading: false,
    errorMessage: "",
    workScopeTypes: [],
    workScopeTypesMap: {}
}

export function WorkScopeTypesReducer(state = { ...initialWorkScopeTypesData }, action) {
    switch (action.type) {
        case IS_SET_WORK_SCOPE_TYPES_LOADING:
            return {
                ...state,
                isLoading: action.isLoading
            }
        case SET_WORK_SCOPE_TYPES_ERROR:
            return {
                ...state,
                errorMessage: action.errorMessage
            }
        case SET_WORK_SCOPE_TYPES:
            let workScopeTypesMap = {};
            action.types.forEach(type => {
                workScopeTypesMap[type.id] = type.name;
            });

            return {
                ...state,
                workScopeTypes: action.types,
                workScopeTypesMap: workScopeTypesMap
            }
    }

    return state;
}

/*****************************Work Types************************************/
export const SET_WORK_TYPES = `${BASE_PATH}/SET_WORK_TYPES`;
export const IS_WORK_TYPES_LOADING = `${BASE_PATH}/IS_WORK_TYPES_LOADING`;
export const SET_WORK_TYPES_ERROR = `${BASE_PATH}/SET_WORK_TYPES_ERROR`;


export const loadWorkTypes = () =>
    (dispatch, getState, client) => {
        dispatch(setIsWorkTypesLoading(true));
        dispatch(setWorkTypesError(""));

        client.get('/work/types').
            then(res => res.data).then(result => {
                dispatch(setIsWorkTypesLoading(false));
                if (result.isSuccess &&
                    result.data.workTypes) {
                    dispatch(setWorkTypes(result.data.workTypes));
                } else {
                    dispatch(setWorkTypesError(result.errorMessage ? result.errorMessage :
                        ERROR_MESSAGES.FAILED_TO_LOAD_WORK_TYPES));
                }
            }).catch(error => {
                dispatch(setIsWorkTypesLoading(false));
                dispatch(setWorkTypesError(ERROR_MESSAGES.FAILED_TO_LOAD_WORK_TYPES));
            });
    }

export const setWorkTypes = (workTypes) => ({
    type: SET_WORK_TYPES,
    workTypes,
});

export const setIsWorkTypesLoading = (isLoading) => ({
    type: IS_WORK_TYPES_LOADING,
    isLoading
});

export const setWorkTypesError = (errorMessage) => ({
    type: SET_WORK_TYPES_ERROR,
    errorMessage,
});

const initialWorkTypeDataState = {
    isLoading: false,
    errorMessage: "",
    workTypes: [],
    workTypesMap: {},
    workTypesMap2: {},
    subWorkTypes: [],
    subWorkTypesMap: {}
}

export function WorkTypesReducer(state = { ...initialWorkTypeDataState }, action) {
    switch (action.type) {
        case IS_WORK_TYPES_LOADING:
            return {
                ...state,
                isLoading: action.isLoading
            }
        case SET_WORK_TYPES_ERROR:
            return {
                ...state,
                errorMessage: action.errorMessage
            }
        case SET_WORK_TYPES:

            let subWorkTypes = [];
            let subWorkTypesMap = {};
            let workTypesMap = {};
            let workTypesMap2 = {};
            action.workTypes.forEach(workType => {
                workTypesMap[workType.id] = workType.name;
                workTypesMap2[workType.id] = workType.subWorkTypes;
                if (workType.subWorkTypes && Array.isArray(workType.subWorkTypes)) {
                    workType.subWorkTypes.forEach(subWorkType => {
                        subWorkTypes.push(subWorkType);
                        subWorkTypesMap[subWorkType.id] = subWorkType.name;
                    })
                }
            });

            return {
                ...state,
                workTypes: action.workTypes,
                workTypesMap: workTypesMap,
                subWorkTypes: subWorkTypes,
                subWorkTypesMap: subWorkTypesMap,
                workTypesMap2: workTypesMap2
            }
    }

    return state;
}


/*****************************Firm Type Data************************************/
export const SET_FIRM_TYPES = `${BASE_PATH}/SET_FIRM_TYPES`;
export const IS_SET_FIRM_TYPES_LOADING = `${BASE_PATH}/IS_SET_FIRM_TYPES_LOADING`;
export const SET_FIRM_TYPES_ERROR = `${BASE_PATH}/SET_FIRM_TYPES_ERROR`;

export const loadFirmTypes = () =>
    (dispatch, getState, client) => {
        dispatch(setIsFirmTypesLoading(true));
        dispatch(setFirmTypesError(""));

        client.get('/firm/types').
            then(res => res.data).then(result => {
                dispatch(setIsFirmTypesLoading(false));
                if (result.isSuccess &&
                    result.data.firmTypes) {
                    dispatch(setFirmTypes(result.data.firmTypes));
                } else {
                    dispatch(setFirmTypesError(result.errorMessage ? result.errorMessage :
                        ERROR_MESSAGES.FAILED_TO_LOAD_FIRM_TYPES));
                }
            }).catch(error => {
                dispatch(setIsFirmTypesLoading(false));
                dispatch(setFirmTypesError(ERROR_MESSAGES.FAILED_TO_LOAD_FIRM_TYPES));
            });
    }

export const setFirmTypes = (firmTypes) => ({
    type: SET_FIRM_TYPES,
    firmTypes,
});

export const setIsFirmTypesLoading = (isLoading) => ({
    type: IS_SET_FIRM_TYPES_LOADING,
    isLoading
});

export const setFirmTypesError = (errorMessage) => ({
    type: SET_FIRM_TYPES_ERROR,
    errorMessage,
});

const initialFirmTypesData = {
    isLoading: false,
    errorMessage: "",
    firmTypes: [],
    firmTypesMap: {}
}

export function FirmTypesReducer(state = { ...initialFirmTypesData }, action) {
    switch (action.type) {
        case IS_SET_FIRM_TYPES_LOADING:
            return {
                ...state,
                isLoading: action.isLoading
            }
        case SET_FIRM_TYPES_ERROR:
            return {
                ...state,
                errorMessage: action.errorMessage
            }
        case SET_FIRM_TYPES:
            let firmTypesMap = {};
            action.firmTypes.forEach(firmType => {
                firmTypesMap[firmType.id] = firmType.name;
            });

            return {
                ...state,
                firmTypes: action.firmTypes,
                firmTypesMap: firmTypesMap
            }
    }

    return state;
}

/*****************************Company Type Data************************************/
export const SET_COMPANY_TYPES = `${BASE_PATH}/SET_COMPANY_TYPES`;
export const IS_SET_COMPANY_TYPES_LOADING = `${BASE_PATH}/IS_SET_COMPANY_TYPES_LOADING`;
export const SET_COMPANY_TYPES_ERROR = `${BASE_PATH}/SET_COMPANY_TYPES_ERROR`;

export const loadCompanyTypes = () =>
    (dispatch, getState, client) => {
        dispatch(setIsCompnayTypesLoading(true));
        dispatch(setCompanyTypesError(""));

        client.get('common/company_types').
            then(res => res.data).then(result => {
                dispatch(setIsCompnayTypesLoading(false));
                if (result.isSuccess &&
                    result.data.companyTypes) {
                    dispatch(setCompnayTypes(result.data.companyTypes));
                } else {
                    dispatch(setCompanyTypesError(result.errorMessage ? result.errorMessage :
                        ERROR_MESSAGES.FAILED_TO_LOAD_COMPANY_TYPES));
                }
            }).catch(error => {
                dispatch(setIsCompnayTypesLoading(false));
                dispatch(setCompanyTypesError(ERROR_MESSAGES.FAILED_TO_LOAD_COMPANY_TYPES));
            });
    }

export const setCompnayTypes = (companyTypes) => ({
    type: SET_COMPANY_TYPES,
    companyTypes,
});

export const setIsCompnayTypesLoading = (isLoading) => ({
    type: IS_SET_COMPANY_TYPES_LOADING,
    isLoading
});

export const setCompanyTypesError = (errorMessage) => ({
    type: SET_COMPANY_TYPES_ERROR,
    errorMessage,
});

const initialCompanyTypesData = {
    isLoading: false,
    errorMessage: "",
    companyTypes: [],
    companyTypesMap: {}
}

export function CompanyTypesReducer(state = { ...initialCompanyTypesData }, action) {
    switch (action.type) {
        case IS_SET_COMPANY_TYPES_LOADING:
            return {
                ...state,
                isLoading: action.isLoading
            }
        case SET_COMPANY_TYPES_ERROR:
            return {
                ...state,
                errorMessage: action.errorMessage
            }
        case SET_COMPANY_TYPES:
            let companyTypesMap = {};
            action.companyTypes.forEach(companyType => {
                companyTypesMap[companyType.id] = companyType.name;
            });

            return {
                ...state,
                companyTypes: action.companyTypes,
                companyTypesMap: companyTypesMap
            }
    }

    return state;
}

/*****************************KYC Data************************************/
export const SET_ADDRESS_PROOFS = `${BASE_PATH}/SET_ADDRESS_PROOFS`;
export const IS_ADDRESS_PROOFS_LOADING = `${BASE_PATH}/IS_ADDRESS_PROOFS_LOADING`;
export const SET_ADDRESS_PROOFS_ERROR = `${BASE_PATH}/SET_ADDRESS_PROOFS_ERROR`;

export const loadAddressProofs = () =>
    (dispatch, getState, client) => {
        dispatch(setIsAddressProofsLoading(true));
        dispatch(setAddressProofsError(""));

        client.get('/address/proofs').
            then(res => res.data).then(result => {
                dispatch(setIsAddressProofsLoading(false));
                if (result.isSuccess &&
                    result.data.proofs) {
                    dispatch(setAddresspProofs(result.data.proofs));
                } else {
                    dispatch(setAddressProofsError(result.errorMessage ? result.errorMessage :
                        ERROR_MESSAGES.FAILED_TO_LOAD_ADDRESS_PROOFS));
                }
            }).catch(error => {
                dispatch(setIsAddressProofsLoading(false));
                dispatch(setAddressProofsError(ERROR_MESSAGES.FAILED_TO_LOAD_ADDRESS_PROOFS));
            });
    }

export const setAddresspProofs = (proofs) => ({
    type: SET_ADDRESS_PROOFS,
    proofs,
});

export const setIsAddressProofsLoading = (isLoading) => ({
    type: IS_ADDRESS_PROOFS_LOADING,
    isLoading
});

export const setAddressProofsError = (errorMessage) => ({
    type: SET_ADDRESS_PROOFS_ERROR,
    errorMessage,
});

const initialAddressProofsData = {
    isLoading: false,
    errorMessage: "",
    proofs: [],
    proofsMap: {}
}

export function AddressProofsDataReducer(state = { ...initialAddressProofsData }, action) {
    switch (action.type) {
        case IS_ADDRESS_PROOFS_LOADING:
            return {
                ...state,
                isLoading: action.isLoading
            }
        case SET_ADDRESS_PROOFS_ERROR:
            return {
                ...state,
                errorMessage: action.errorMessage
            }
        case SET_ADDRESS_PROOFS:
            let proofsMap = {};
            action.proofs.forEach(proof => {
                proofsMap[proof.id] = proof.name;
            });

            return {
                ...state,
                proofs: action.proofs,
                proofsMap: proofsMap
            }
    }

    return state;
}

/*****************************Address Data************************************/
export const SET_STATES = `${BASE_PATH}/SET_STATES`;
export const IS_STATES_LOADING = `${BASE_PATH}/IS_STATES_LOADING`;
export const SET_STATES_ERROR = `${BASE_PATH}/SET_STATES_ERROR`;


export const loadAddressStates = () =>
    (dispatch, getState, client) => {
        dispatch(setIsStatesLoading(true));
        dispatch(setStatesError(""));

        client.get('/address/states').
            then(res => res.data).then(result => {
                dispatch(setIsStatesLoading(false));
                if (result.isSuccess &&
                    result.data.states) {
                    dispatch(setAddressStates(result.data.states, result.data.cities));
                } else {
                    dispatch(setStatesError(result.errorMessage ? result.errorMessage :
                        ERROR_MESSAGES.FAILED_TO_LOAD_STATES));
                }
            }).catch(error => {
                dispatch(setIsStatesLoading(false));
                dispatch(setStatesError(ERROR_MESSAGES.FAILED_TO_LOAD_STATES));
            });
    }

export const setAddressStates = (states, cities) => ({
    type: SET_STATES,
    states,
    cities
});

export const setIsStatesLoading = (isLoading) => ({
    type: IS_STATES_LOADING,
    isLoading
});

export const setStatesError = (errorMessage) => ({
    type: SET_STATES_ERROR,
    errorMessage,
});

const initialAddressDataState = {
    isLoading: false,
    errorMessage: "",
    states: [],
    statesMap: {},
    cities: [],
    citiesMap: {}
}

export function AddressDataReducer(state = { ...initialAddressDataState }, action) {
    switch (action.type) {
        case IS_STATES_LOADING:
            return {
                ...state,
                isLoading: action.isLoading
            }
        case SET_STATES_ERROR:
            return {
                ...state,
                errorMessage: action.errorMessage
            }
        case SET_STATES:

           let statesMap = {};
            action.states.forEach(state => {
                statesMap[state.id] = state;
            });

            let cities = [];
            let citiesMap = {};
            if (action.cities && Array.isArray(action.cities)) {
                action.cities.forEach(city => {
                    cities.push(city);
                    citiesMap[city.id] = city.name;
                })
            }

            return {
                ...state,
                states: action.states,
                statesMap: statesMap,
                cities: cities,
                citiesMap: citiesMap
            }
    }

    return state;
}

/*****************************App Messages and Loading***************************************/
export const SET_MESSAGE = `${BASE_PATH}/SET_MESSAGE`;
export const CLEAR_MESSAGE = `${BASE_PATH}/CLEAR_MESSAGE`;
export const SET_LOAING = `${BASE_PATH}/SET_LOAING`;
export const SET_GLOBAL_STATE_LOADED = `${BASE_PATH}/SET_GLOBAL_STATE_LOADED`;


export const loadGlobalState = () =>
    (dispatch, getState, client) => {
        let state = getState();
        let APP_DATA = state.APP_DATA;
        if (APP_DATA.isInitialStateLoaded) {
            return;
        }

        let authState = state.AUTH;
        let user = authState.user ? authState.user : { role: "none" };
        if (authState.isSignedIn) {
            switch (user.role) {
                case ROLE_TYPE.COMPANY:
                    dispatch(loadCompanyProfile());
                    break;
                case ROLE_TYPE.VENDOR:
                    dispatch(loadVendorProfile());
                    break;
                case ROLE_TYPE.COMPANY_HR:
                case ROLE_TYPE.COMPANY_CONTRACTS:
                    dispatch(loadUserProfile());
                    break;
            }
            dispatch(setGlobalStateLoaded(true));
        }
    }

export const setGlobalMessage = (message, messageType) => ({
    type: SET_MESSAGE,
    message,
    messageType
});

export const clearGloablMessage = () => ({
    type: CLEAR_MESSAGE,
});

export const setGlobalStateLoaded = (isLoaded) => ({
    type: SET_GLOBAL_STATE_LOADED,
    isLoaded
});

export const setLoading = isLoading => ({
    type: SET_LOAING,
    isLoading
});

const initialState = {
    message: '',
    isInitialStateLoaded: false,
    messageType: ALERT_SEVERITY.INFO,
    isLoading: false
}

export default function reducer(state = { ...initialState }, action) {
    switch (action.type) {
        case SET_MESSAGE:
            return {
                ...state,
                message: action.message,
                messageType: action.messageType
            };
        case SET_LOAING:
            return {
                ...state,
                isLoading: action.isLoading,
            };
        case CLEAR_MESSAGE:
            return {
                ...state,
                message: '',
                messageType: ALERT_SEVERITY.INFO
            };
        case SET_GLOBAL_STATE_LOADED:
            return {
                ...state,
                isInitialStateLoaded: action.isLoaded
            }
        default:
            break;
    }

    return state;
}